import { useContext, useEffect, useState } from 'react'
import useAudioPlayer from '../../../../modules/hooks/webview/caf/etc/useAudioPlayer'
import { ICON_PAUSE_BUTTON_GREY_BG, ICON_PLAY_BUTTON } from '../../../../modules/svg/svg'
import { COLORS } from '../../../../modules/vars'
import { AccordionContext, IsSameContext } from '../highlight/AccordionContainer'

type PlayerPropsType = {
  src: string
  id: number
  otherAccordionOpened?: boolean
  duration?: number
  onPlay?: () => void
}

const Bar = ({ duration, curTime, onTimeUpdate }) => {
  const formatTime = (time: number) => {
    if (time == 0) return '00:00'
    let minutes, seconds
    minutes = Math.floor(time / 60)
    minutes = minutes >= 10 ? minutes : '0' + minutes
    seconds = Math.floor(time % 60)
    seconds = seconds >= 10 ? seconds : '0' + seconds
    return minutes + ':' + seconds
  }
  const curPercentage = isNaN(curTime / duration) ? 0 : curTime / duration
  const progressBarId = 'progress_bar'
  const mouseE = 'mousedown'
  const touchE = 'touchmove'
  const calcClickedTime = (e) => {
    const clickPositionInPage = e.type === touchE ? e.changedTouches[0]?.pageX : e.pageX
    const bar = document.getElementById(progressBarId)
    const barStart = bar.getBoundingClientRect().left + window.scrollX
    const barWidth = bar.offsetWidth
    const clickPositionInBar = clickPositionInPage - barStart
    const timePerPixel = duration / barWidth
    return timePerPixel * clickPositionInBar
  }

  function handleTimeDrag(e) {
    onTimeUpdate(calcClickedTime(e))
    console.log(calcClickedTime(e), 'e')

    const updateTimeOnMove = (eMove) => {
      console.log(eMove, calcClickedTime(eMove), 'eMove')
      onTimeUpdate(calcClickedTime(eMove))
    }

    // PC 마우스 이벤트
    if (e.type === mouseE) {
      document.addEventListener('mousemove', updateTimeOnMove)
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', updateTimeOnMove)
      })
    } else {
      // 모바일 터치 이벤트
      document.addEventListener('touchstart', updateTimeOnMove)
      document.addEventListener('touchend', () => {
        document.removeEventListener('touchstart', updateTimeOnMove)
      })
    }
  }
  return (
    <div className="relative mt-6 flex-1" onMouseDown={(e) => handleTimeDrag(e)} onTouchMove={(e) => handleTimeDrag(e)}>
      <div
        id={progressBarId}
        style={{
          background: `linear-gradient(to right, ${COLORS.PURPLE500} ${curPercentage * 100}%, ${COLORS.GRAY200} 0)`,
        }}
        className="ml-[10px] h-[4px] w-[100%] rounded-full"
      >
        <span
          className="absolute top-[-8px] ml-[-4px] h-[20px] w-[20px] rounded-full border border-white bg-purple-500"
          // 원 지름이 20px이라서 -10px 해줌 (progressBar 내에서 튀어나가지 않도록)
          style={{ left: `${curPercentage * 100}%` }}
        ></span>
      </div>
      <div className="mt-[7px] flex items-center justify-between text-[12px]  text-gray-500">
        <div className="pr-[4px]">{formatTime(curTime)}</div>
        <div className="">{formatTime(+duration)}</div>
      </div>
    </div>
  )
}

const AudioController = ({ src, id, onPlay }: PlayerPropsType) => {
  const audioId = `audio_${id}`
  const [isReady, setIsReady] = useState(false)
  const { curTime, playing, setPlaying, setClickedTime, pauseAudio, duration } = useAudioPlayer({
    audioId: audioId,
    isReady,
  })

  const [getAccordionContext] = useContext(AccordionContext)
  const [getIsSameContext, setIsSameContext] = useContext(IsSameContext)

  const otherAccordionOpened = getAccordionContext !== id
  const onCanPlayAudio = () => {
    setIsReady(true)
  }
  useEffect(() => {
    // 다른 아코디언이 열리거나, current 아코디언이 토글되어 닫혔을 때
    if (otherAccordionOpened || getIsSameContext) {
      pauseAudio()
      setPlaying(false)
      setIsSameContext(false)
    }
  }, [otherAccordionOpened, getIsSameContext, pauseAudio, setPlaying, setIsSameContext])
  return (
    <>
      <div className="rounded-sm bg-gray-50 p-[12px] pb-[8px] pr-[20px]">
        <div className="flex items-center justify-between">
          <div className="flex-0 pr-[12px] pt-[4px]">
            {/* Pause & play button */}
            {playing ? (
              <button onClick={() => setPlaying(false)} className="focus:outline-none">
                <img src={ICON_PAUSE_BUTTON_GREY_BG} width={28} height={28} className="max-w-none" alt="pause" />
              </button>
            ) : (
              <button onClick={() => setPlaying(true)} className="focus:outline-none">
                <img src={ICON_PLAY_BUTTON} width={28} height={28} className="max-w-none" alt="play" />
              </button>
            )}
          </div>
          <div className="flex flex-1 translate-x-[-5px] items-center justify-center">
            <Bar curTime={curTime} duration={duration} onTimeUpdate={(time) => setClickedTime(time)} />
          </div>
          {src && (
            <audio
              src={src}
              id={audioId}
              onEnded={() => setPlaying(false)}
              onCanPlay={onCanPlayAudio}
              onPlay={() => {
                onPlay && onPlay()
              }}
            />
          )}
        </div>
      </div>
    </>
  )
}

AudioController.displayName = 'AudioController'

export default AudioController
